import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';

import { EmptyState, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import { VaniaLoadingSystem, VaniaTableSkeleton } from '../../../app/components/loading';
import type { Service } from '../../services/types/service.types';
import { ServiceStatusBadge } from '../../services/components/ServiceStatusBadge';

export interface TenantServicesSectionProps {
  services: Service[];
  loading: boolean;
  error: string | null;
}

export function TenantServicesSection({ services, loading, error }: TenantServicesSectionProps) {
  const activeCount = services.filter((service) => service.status === 'active').length;
  const inactiveCount = services.filter((service) => service.status === 'inactive').length;

  return (
    <div className="vania-tenant-services-content">
      <div className="vania-tenant-services-header">
        <div>
          <h2 className="vania-tenant-workspace-card-title">سرویس‌ها</h2>
        </div>
        <div className="vania-tenant-services-summary" aria-label="خلاصه وضعیت سرویس‌ها">
          <span>کل {formatPersianNumber(services.length)}</span>
          <span className="is-active">فعال {formatPersianNumber(activeCount)}</span>
          <span className="is-inactive">غیرفعال {formatPersianNumber(inactiveCount)}</span>
        </div>
      </div>

      {loading ? (
        <VaniaLoadingSystem mode="content" label="در حال بارگذاری سرویس‌های تننت">
          <VaniaTableSkeleton columns={6} rows={5} className="vania-tenant-services-skeleton" />
        </VaniaLoadingSystem>
      ) : error ? (
        <p className="vania-tenants-status vania-tenants-status-error" role="alert">{error}</p>
      ) : services.length === 0 ? (
        <EmptyState message="سرویسی برای این تننت ثبت نشده است." />
      ) : (
        <div className="vania-tenant-services-table-scroll">
          <table className="vania-tenant-services-table">
            <thead>
              <tr>
                <th>نام سرویس</th>
                <th>شناسه یکتا</th>
                <th>نوع</th>
                <th>وضعیت</th>
                <th>تاریخ ایجاد</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {services.map((service) => (
                <tr key={service.id ?? service.slug}>
                  <td className="vania-tenant-services-name">{service.name}</td>
                  <td dir="ltr">{service.slug}</td>
                  <td>{service.type}</td>
                  <td><ServiceStatusBadge status={service.status} /></td>
                  <td dir="ltr">{formatSolarDate(service.created_at)}</td>
                  <td className="vania-tenant-services-actions">
                    {service.id === null ? (
                      <span aria-label="شناسه سرویس موجود نیست">—</span>
                    ) : (
                      <Link to={`/services/${service.id}`} aria-label={`مشاهده ${service.name}`} title="مشاهده">
                        <Eye size={15} aria-hidden="true" />
                        <span className="sr-only">مشاهده</span>
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
